export default __webpack_public_path__ + "static/media/handsoftheunderworld.a3885fe6.png";